import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-excel-productsize-chart',
  templateUrl: './excel-productsize-chart.component.html',
  styleUrls: ['./excel-productsize-chart.component.scss']
})
export class ExcelProductsizeChartComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  @Input() tabledata: any[] = [{  },];
  @Output() setData = new EventEmitter<any>();

  ngOnInit(): void {    
    this.tableHeaders=Object.keys(this.tabledata[0]);
  }

  

  tableHeaders: string[] = Object.keys(this.tabledata[0]);
  editingColumn: string | null = null;
  isEditing = false;


  delete(i){
    this.tabledata.splice(i, 1);
    this.emit()
  }

  removeColumn() {
    const columnToRemove = prompt('Enter column name to remove');

    if (columnToRemove && this.tableHeaders.includes(columnToRemove)) {
      this.tableHeaders = this.tableHeaders.filter(header => header !== columnToRemove);
      this.tabledata.forEach(row => {
        delete row[columnToRemove];
      });
    }
    this.emit()
  }

  addColumn() {
    const newColumnName = prompt('Enter new column name');
    if (newColumnName) {
      this.tableHeaders.unshift(newColumnName);
      this.tabledata.forEach((row, index) => {
        row[newColumnName] = '' // You can set the default value here if needed
      })
    }
    this.emit()
  }

  add_Column(): void {
    const newColumnName = prompt('Enter new column name');

    if (newColumnName) {
      this.tableHeaders.push(newColumnName);
      this.tabledata.forEach(row => {
        row[newColumnName] = ''; // You can set the default value here if needed
      })
    }
    this.emit()
  }

  insertTop(){
    const newRow: any = {};
    this.tableHeaders.forEach(header => {
      newRow[header] = '';
    });
    this.tabledata.unshift(newRow);
    this.emit()
  }

  

  insertBottom(){
    const newRow: any = {};
    this.tableHeaders.forEach(header => {
      newRow[header] = ''; 
    });
    this.tabledata.push(newRow);
    this.emit()

  }


  editRow(rowIndex: number): void {
    this.tabledata[rowIndex].editing = true;
    this.emit()
  }

  saveRow(rowIndex: number): void {
    this.tabledata[rowIndex].editing = false;
    this.emit()
  }

  cancelEdit(rowIndex: number): void {
    this.tabledata[rowIndex].editing = false;
    this.emit()
  }

  saveAll(){
    console.log(this.tabledata);
    this.emit()
   
    
  }

  emit(){
    this.setData.emit(this.tabledata)
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    constructor(private router: Router) {
        this.url = this.router.url || '';
            this.router.events
              .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
              .subscribe(() => { this.url = this.router.url || ''; });
    }
}
